import { isCventEmployee } from './isCventEmployee.js';
/**
 * Based on the user traits, figures out the appropraite user group
 * @param trait
 */
export function getUserGroup(trait) {
    if (isCventEmployee(trait)) {
        return 'employee';
    }
    return 'external';
}
//# sourceMappingURL=getUserGroup.js.map